import React from 'react';
import FAQsBreadcrumbs from '../components/FAQsBreadcrumbs';
import FAQsMain from '../components/FAQsMain';

const FAQs = () => {
  return (
    <>
      <FAQsBreadcrumbs />
      <FAQsMain />
    </>
  );
};

export default FAQs;
